export const question_types_single_multi = [
    { code: 'Multichoice', label: 'Multichoice' },
    { code: 'Basic', label: 'Basic' },
];